import styled, {css} from 'styled-components';

import {
  getColor,
  getFontWeight,
  getRem,
  gts,
  ms,
} from '../../../../../../../../styles';
import {Text} from '../../../../../../../../uikit/Text';
import {TextInput} from '../../../../../../../../uikit/TextInput';
import {View} from '../../../../../../../../uikit/View';
import {platform} from '../../../../../../../../utils/platform';

export const Container = styled(View)`
  position: relative;
  justify-content: center;
  align-items: center;
  border-radius: ${gts('borderRadius.sm')};
  border: 1px solid ${getColor('border.light')};

  ${platform.isNative
    ? css`
        height: ${ms(80)};
        gap: ${gts('gap.sm')};
      `
    : css`
        column-gap: ${ms(10)};
      `}
`;

export const Input = styled(TextInput)`
  border: none;
  caret-color: ${getColor('static.accent.trackers')};
  font-size: ${getRem(32)};
  line-height: ${getRem(40)};
  font-weight: ${getFontWeight('bold')};
  text-align: end;
  background-color: transparent;
  padding: 0;
  width: 100%;
  min-width: 0;

  ${platform.isNative &&
  css`
    padding: 0;
  `}
`;

export const InputError = styled(Text).attrs({variant: 'label.la'})`
  position: absolute;
  top: ${ms(2)};
  left: ${ms(4)};
  color: ${getColor('text.error')};
`;

export const Half = styled(View)<{align: 'left' | 'right'}>`
  flex: 1;
  min-width: 0;
  justify-content: ${p => (p.align === 'left' ? 'flex-start' : 'flex-end')};
`;

export const Unit = styled(Text).attrs({weight: 'bold'})`
  font-size: ${getRem(32)};
  line-height: ${getRem(40)};
`;
